import React, { forwardRef } from 'react';

export interface ListStatusFooterProps {
  loadingMore: boolean;
  hasMore: boolean;
  allowNoMore: boolean;
  onRefresh?: () => void;
  refreshing?: boolean;
}

export const ListStatusFooter = forwardRef<HTMLDivElement, ListStatusFooterProps>(({ loadingMore, hasMore, allowNoMore, onRefresh, refreshing }, ref) => {
  return (
    <div
      ref={ref}
      style={{ minHeight: '80px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '16px 0' }}
    >
      {loadingMore && (
        <div className="loading-more">
          加载更多...
        </div>
      )}
      {!hasMore && allowNoMore && (
        <div className="no-more">
          已加载全部视频
        </div>
      )}

      {/* 刷新按钮 - 始终显示（当有内容且有刷新函数时） */}
      {allowNoMore && onRefresh && (
        <button
          className={`refresh-button ${refreshing ? 'refreshing' : ''}`}
          onClick={onRefresh}
          disabled={refreshing}
          style={{
            padding: '10px 20px',
            backgroundColor: 'var(--color-primary)',
            color: 'white',
            border: 'none',
            borderRadius: '24px',
            cursor: refreshing ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.2s ease',
            opacity: refreshing ? 0.7 : 1,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            minWidth: '120px',
            justifyContent: 'center'
          }}
        >
          {refreshing ? (
            <>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="spinning">
                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                <path d="M21 3v5h-5"/>
                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                <path d="M8 16H3v5"/>
              </svg>
              刷新中...
            </>
          ) : (
            <>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                <path d="M21 3v5h-5"/>
                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                <path d="M8 16H3v5"/>
              </svg>
              刷新数据
            </>
          )}
        </button>
      )}
    </div>
  );
});

export default ListStatusFooter;


